module.exports = __webpack_public_path__ + "img/thumbnail_ThomsonsGazelle_m_normal.1a4cfb9e.png";